import React from "react";
import { CATEGORY_CHIPS, NEUTRAL_CHIP } from "./constants";

// Chip base — desktop 10.5px / pad 4px 10px / ls .09em (design 0.5);
// mobile 10px / pad 3px 9px / ls .08em (design 1f).
const BASE =
  "inline-flex items-center px-[9px] py-[3px] text-[10px] tracking-[0.08em] sm:px-2.5 sm:py-1 sm:text-[10.5px] sm:tracking-[0.09em] rounded-full font-extrabold whitespace-nowrap";

// Category pill (NEW FEATURE / IMPROVEMENT / ANNOUNCEMENT / POLL).
export const CategoryChip = ({ category }) => {
  const c = CATEGORY_CHIPS[category] || CATEGORY_CHIPS.announcement;
  return (
    <span className={BASE} style={{ background: c.bg, color: c.color }}>
      {c.label}
    </span>
  );
};

// PINNED marker — neutral pill with a small leading dot (design 1a, dot S15:
// 5px desktop / 4px mobile).
export const PinnedChip = () => (
  <span
    className={`${BASE} gap-[5px] sm:gap-1.5`}
    style={{ background: NEUTRAL_CHIP.bg, color: NEUTRAL_CHIP.color }}
  >
    <span
      className="w-1 h-1 sm:w-[5px] sm:h-[5px] rounded-full inline-block"
      style={{ background: NEUTRAL_CHIP.color }}
    />
    PINNED
  </span>
);

// CLOSED marker for a finished poll (design 1d · state 3).
export const ClosedChip = () => (
  <span className={BASE} style={{ background: NEUTRAL_CHIP.bg, color: NEUTRAL_CHIP.color }}>
    CLOSED
  </span>
);
